var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.00244141,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#DC625C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7524 5.75C10.7524 5.33437 10.4181 5 10.0024 5C9.58682 5 9.25244 5.33437 9.25244 5.75V7H8.00244C6.89932 7 6.00244 7.89687 6.00244 9V9.5V11V19C6.00244 20.1031 6.89932 21 8.00244 21H18.0024C19.1056 21 20.0024 20.1031 20.0024 19V11V9.5V9C20.0024 7.89687 19.1056 7 18.0024 7H16.7524V5.75C16.7524 5.33437 16.4181 5 16.0024 5C15.5868 5 15.2524 5.33437 15.2524 5.75V7H10.7524V5.75ZM7.50244 11H18.5024V19C18.5024 19.275 18.2774 19.5 18.0024 19.5H8.00244C7.72744 19.5 7.50244 19.275 7.50244 19V11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.2973225a1dd0bc8d12da3af1bbfe45a6.svg";
export { ForwardRef as ReactComponent };